// Create a new file: src/components/PurchasePopup.jsx
import React from 'react';
import { Card } from './ui/card';
import { Button } from './ui/button';
import { X, MessageSquare, Tag, Sparkles } from 'lucide-react';

const PurchasePopup = ({ plugin, isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 backdrop-blur-sm">
      <Card className="relative max-w-md w-full mx-4 glass-strong" style={{ borderRadius: '0px', padding: '32px' }}>
        <button
          onClick={onClose}
          className="absolute right-4 top-4 text-white hover:text-[#00FFD1] transition-colors"
        >
          <X className="w-6 h-6" />
        </button>
        
        <div className="text-center mb-6">
          <Sparkles className="w-12 h-12 mx-auto mb-4" style={{ color: '#00FFD1' }} />
          <h2 className="text-2xl font-bold mb-2" style={{ color: '#FFFFFF', fontFamily: 'Orbitron, sans-serif' }}>
            Purchase {plugin.name}
          </h2>
          <p className="text-lg" style={{ color: 'rgba(255, 255, 255, 0.85)' }}>
            ${plugin.price} • One-time payment
          </p>
        </div>

        <div className="space-y-4 mb-6">
          <div className="p-4 glass" style={{ borderRadius: '0px', border: '1px solid rgba(14, 165, 255, 0.3)' }}>
            <h3 className="text-lg font-semibold mb-2 flex items-center gap-2" style={{ color: '#FFFFFF' }}>
              <MessageSquare className="w-5 h-5" style={{ color: '#0EA5FF' }} />
              Main Purchase Channel
            </h3>
            <p className="text-sm mb-3" style={{ color: 'rgba(255, 255, 255, 0.85)' }}>
              Join our main Discord channel to purchase this plugin and get support
            </p>
            <Button
              onClick={() => window.open('https://discord.gg/CTKwc5vcMy', '_blank')}
              className="w-full"
              style={{
                background: '#0EA5FF',
                color: '#000000',
                borderRadius: '0px',
                padding: '12px',
                fontWeight: 600,
              }}
            >
              <MessageSquare className="w-4 h-4 mr-2 inline" />
              Purchase on Discord
            </Button>
          </div>

          <div className="p-4 glass" style={{ borderRadius: '0px', border: '1px solid rgba(0, 255, 209, 0.3)' }}>
            <h3 className="text-lg font-semibold mb-2 flex items-center gap-2" style={{ color: '#FFFFFF' }}>
              <Tag className="w-5 h-5" style={{ color: '#00FFD1' }} />
              Get 15% Discount
            </h3>
            <p className="text-sm mb-3" style={{ color: 'rgba(255, 255, 255, 0.85)' }}>
              Join our second channel to get 15% off on all premium plugins
            </p>
            <Button
              onClick={() => window.open('https://discord.gg/rXpsm4ZpG', '_blank')}
              className="w-full"
              style={{
                background: 'rgba(0, 255, 209, 0.1)',
                color: '#00FFD1',
                borderRadius: '0px',
                padding: '12px',
                fontWeight: 600,
                border: '1px solid rgba(0, 255, 209, 0.3)',
              }}
            >
              <Tag className="w-4 h-4 mr-2 inline" />
              Join Discount Channel
            </Button>
          </div>
        </div>

        <div className="text-center">
          <p className="text-sm" style={{ color: 'rgba(255, 255, 255, 0.7)' }}>
            After joining Discord, mention the plugin name to complete your purchase
          </p>
        </div>
      </Card>
    </div>
  );
};

export default PurchasePopup;